// modSelectors.js

export const selectTrainingData = (state) => state.training.trainings; // Selector to get meals data
export const selectLoading = (state) => state.training.loading; // Selector to get loading state
export const selectTotal = (state) => state.training.total; // Selector for total pages
export const selectError = (state) => state.training.error; // Selector for error state
export const selectCurrentPage = (state) => state.training.page;
export const selectLimit = (state) => state.training.limit;
export const selectAvailableCoaches = (state) =>
  state.training.availableCoaches;
export const selectLevelDetails = (state) => state.training.levelData;
export const selectMasterclasses = (state) => state.training.masterclasses;
export const selectMasterclassLoading = (state) =>
  state.training.masterclassLoading;
export const selectMasterclassError = (state) =>
  state.training.masterclassError;
export const selectSelectedMasterclass = (state) =>
  state.training.selectedMasterclass;
export const selectTotalMasterclasses = (state) =>
  state.training.totalMasterclasses;
export const selectMasterclassTrainings = (state) =>
  state.training.masterclassTrainings;
export const selectMasterclassTrainingLoading = (state) =>
  state.training.masterclassTrainingLoading;
export const selectMasterclassTrainingError = (state) =>
  state.training.masterclassTrainingError;
export const selectTotalMasterclassTrainings = (state) =>
  state.training.totalMasterclassTrainings;
